<template>
  <VitePwaManifest />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <RiseToast v-model="$toastItems" class="z-30" />
</template>
